import { PubSub } from '@aws-amplify/pubsub'
//import { PubSub } from '@aws-amplify'
import {  useEffect, useState } from "react";
import * as React from 'react';
import { alpha, styled } from '@mui/material/styles';
import { red, yellow, green, blue, purple } from '@mui/material/colors';
import Switch from '@mui/material/Switch';
import Button, { ButtonProps } from '@mui/material/Button';
import { Container, Table } from '@mui/material';
import { TableCell, TextareaAutosize } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import IconButton from '@mui/material/IconButton';
import { TextField } from '@mui/material';
import Moment from 'react-moment';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import  RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'; 
import ButtonGroup from '@mui/material/ButtonGroup';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import useLocalStorage  from "../../useLocalStorage";
import CardActions from '@mui/material/CardActions';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ShareIcon from '@mui/icons-material/Share';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from '@mui/material/Box';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
//import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import CardHeader from '@mui/material/CardHeader';
import Avatar from '@mui/material/Avatar';
import DataGridDemo from '../DataGrid/datagrid';
import HeartBrokenIcon from '@mui/icons-material/HeartBroken';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import SwitchPoint from '../Uswitch/switchpoint'


const payload_relay = {Output:'Relay',Relays:[{relay:'Relay1-i',state:2},{relay:'Relay2-i',state:2}]};

const glen_payload = `
{
    "Output":"Relay",
    "Relays":[
    {
    "relay":"Relay1-i",
    "state":2,
    "invert":"true",
    "latch":"true",
    "pulse":"false",
    "show":"true",
    "offTxt":"open",
    "onTxt":"OnIsOnMyFriend",
    "loClr":"White",
    "hiClr":"Blue",
    "mom":442,
    "mode":"Scheduled",
    "post":"Last",
    "email":"Off",
    "log":"Time"
    },
    {
    "relay":"Relay2-i",
    "state":2,
    "invert":"true",
    "latch":"true",
    "pulse":"false",
    "show":"true",
    "offTxt":"slow",
    "onTxt":"fast",
    "loClr":"White",
    "hiClr":"Blue",
    "mode":"Watchdog",
    "mom":344,
    "post":"Last",
    "log":"Event"
    }
    ]
    }
`

const YellowSwitch = styled(Switch)(({ theme }) => ({
  '& .MuiSwitch-switchBase.Mui-checked': {
    color: yellow[600],
    '&:hover': {
      backgroundColor: alpha(yellow[600], theme.palette.action.hoverOpacity),
    },
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: yellow[600],
  },
}));


const theme = createTheme({
  palette: {
      primary: {
          main: "#FF0000",
          contrastText: "#ffffff",
      },
      secondary: {
          main: "#808080",
          contrastText: "#ffffff",
      },
      success: {
        main: "#0B6623",
        contrastText: "#ffffff",
      },
      error: {
        main: "#800000",
        contrastText: "#ffffff",
      },
  },
});


export default function Uswitch(props) {
  console.log(props);
  var switchInfo = props.switchInfo
  var s_string = JSON.stringify(switchInfo);
  console.log('entering uSwitch.js=', s_string);

  var relayActivatedIcon = <TaskAltIcon />
  var relayAtRestIcon = < RadioButtonUncheckedIcon/>

  const [isSubscribed, setIsSubscribed] =  useLocalStorage(switchInfo.serialNumber + "/isSubscribed" , false);
  const [subCounter, setSubCounter] = useState(0);
  const [MyPubSub, setMyPubSub] = useState();
  const [myTopic, setMyTopic] = useState("policy/relays/"); // + switchInfo.switch_id.S);
  const [relay1Color, setRelay1Color] = useState("secondary");
  const [relay2Color, setRelay2Color] = useState("secondary");
  const [relay1Icon,setRelay1Icon] = useState(relayAtRestIcon)
  const [relay2Icon,setRelay2Icon] = useState(relayAtRestIcon)
  const [gpio1Color, setGpio1Color] = useState("secondary");
  const [gpio2Color, setGpio2Color] = useState("secondary");
  const [adc1Volts, setAdc1Volts] = useState([]);
  const [relay1State, setRelay1State] = useState(0)
  const [relay2State, setRelay2State] = useState(0);
  const [relayTime, setRelayTime] = useState(Date.now());
  const [messageData, setMessageData] = useState([]);
  const [lastMessage, setLastMessage] = useState("");
  const label = { inputProps: { 'aria-label': 'Color switch demo' } };


function messageShaping(message)
  {    
    var event_time;
    // clean up the relay1-i and adcin1-i properties    
    // console.log('msg shape',message);
    //var msg_data = JSON.stringify(message.value);
    var msg_data = JSON.stringify(message);    
    var msg_json = JSON.parse(msg_data.replaceAll("-i",""));

    if (msg_data === msg_json) {
      console.log("same value. code not needed")
    } 
    
    if (msg_json.hasOwnProperty('Output')) {
      console.log('Output.in.message',msg_json)
      var output_type = msg_json.Output;
      if (output_type === "Test") {
        console.log("returning ...output type is Test");
        var dataObjectCommand = {"Test": 'test'};
        return dataObjectCommand;
      }
      console.log('has output, not test, call it Command')
      var dataObjectCommandOutput = {Command: msg_json.Relays[0]};
      return dataObjectCommandOutput;
    } 

    if (msg_json.hasOwnProperty('IOTtime')) {
      event_time = Date.parse(msg_json.IOTtime);
    }

    if (msg_json.hasOwnProperty('Rel1')) {
      var dataObject =  {Relay1: msg_json.Rel1, Relay2: msg_json.Rel2, relayTime: event_time, IOTtime: event_time}; //Date.parse(md.relayTime));
      return dataObject;
    }

    if (msg_json.hasOwnProperty('ADC1')) {
      var dataObjectAd = {adVolts: msg_json.ADCin1, adTime: event_time, IOTtime: event_time};
      return dataObjectAd;
    }

    if (msg_json.hasOwnProperty('GPIO1')) {
      var dataObjectGpio= {GPIO1: msg_json.GPIO1, GPIO2: msg_json.GPIO2, gpioTime: msg_json.gpioTime, IOTtime: event_time};
      return dataObjectGpio;
    }

    if (msg_json.hasOwnProperty('Test')) {
      var dataObjectTest= {Test: msg_json.val0, testTime: msg_json.IOTtime, IOTtime: event_time};
      return dataObjectTest;
    }
    //shouldnt get here
    messageShaping =  {NotExpected: msg_json};
  }

  function handleSubscriptionChange(e) {
    e.preventDefault();
    console.log('SubscriptionChangeEvent', e);
    var t = e.target;
    console.log(t.checked);
    
    if (t.checked) { 
      console.log('its checked. Now Subscribing');
      console.log('target.checked',t.checked);
      setIsSubscribed(true);
      uhcThingSubscribe();    
    } 
    else {
      console.log('t.not checked. will turn subscription off');
      setIsSubscribed(false);    
      stopAll();
      console.log('back from explicit stopAll')    
    }
  }

  async function relayChange(e) {
    e.preventDefault();
    console.log('!!!!!!!!!!!!relay change event!!!!!!!!!!!',e);
    console.log('target checked value', e.target.checked)
    console.log('name of changed',e.target.name);
    console.log('odd but logging nothing thispubsub now');


    var set_val = 0 ;
    var pub_payload = "";
    if (e.target.checked === true ) set_val = 1;          
    if (e.target.name === "relay2") {
      //setRelay2State(set_val);    
      pub_payload = JSON.parse(`{"Output":"Relay","Relays":[{"relay":"Rel2", "state":${set_val}}]}`);
    }
    else {
      pub_payload = JSON.parse(`{"Output":"Relay","Relays":[{"relay":"Rel1", "state":${set_val}}]}`); // was "Relay1-i"
    }    
    console.log('begin the pub out: topic/msg', myTopic, pub_payload)
    await MyPubSub.publish({topics:myTopic, message:pub_payload});    
    //await my_AWSIoT.publish({topics:myTopic, message:JSON.stringify(pub_payload)});
    //await my_AWSIoT.publish(myTopic, JSON.stringify(pub_payload));
    //await my_AWSIoT.publish("policy/relays/4091511c51cd", "{'Output':123}");

    //console.log('pub topic',PUB_TOPIC)
    
    //await PubSub.publish({topics:[myTopic], message:pub_payload});
    console.log('pub done')
    //{Output:'Relay',Relays:[{relay:'Relay1-i',state:2},
    // `{Output:'Relay',Relays:[{relay:'Relay2-i':${set_val}}]}`
    //readStateAndPublish(pub_payload);
  }

  async function message_setter(raw_message) {

    const md = messageShaping(raw_message); 
    var dtstring = "";

    if (md.hasOwnProperty('IOTtime')) {
       dtstring = Date(md.IOTtime) //.toDateString();          
       //delete data_payload.IOTtime; // no need to time in data now it's the event_time
    }

    setMessageData([                
      { time: dtstring, message: JSON.stringify(raw_message) } ,
      ...messageData
    ]);

    if (md.hasOwnProperty('adVolts')) {
      var volts_now = md.adVolts;
      setAdc1Volts(volts_now);
    }

    if (md.hasOwnProperty('Relay1')) {
      setRelay1State(md.relay1);
      setRelayTime(md.relayTime);          
      if (md.Relay1 === 1) {
        setRelay1Color("success");
        setRelay1Icon(relayAtRestIcon);
        setRelay1State(1);
      } else {
        setRelay1Color("error");
        setRelay1Icon(relayActivatedIcon);
        setRelay1State(0);
      };
      if (md.Relay2 === 1) {setRelay2Color("success");setRelay2Icon(relayAtRestIcon);setRelay2State(1);} else {setRelay2Color("error");setRelay2Icon(relayActivatedIcon);setRelay2State(0);};
    }
    if (md.hasOwnProperty('GPIO1')) {
      if (md.GPIO1 === "Off") {setGpio1Color("success");} else {setGpio1Color("error");};
      if (md.GPIO2 === "Off") {setGpio2Color("success");} else {setGpio2Color("error");};
    }
  }

  async function uhcThingSubscribe() {
    if (subCounter === 0) {
      setSubCounter(subCounter+1); 
      var listen_topic = "policy/relays/" + switchInfo.switch_id.S;
      setMyTopic(listen_topic);
      console.log('start the useEffect first-time-one-time on topic',listen_topic);
      // , { provider: 'AWSIoTProvider' }
      const mysub = PubSub.subscribe({topics:[listen_topic]}).subscribe({
      //my_new_pubsub.subscribe({topics:listen_topic}).subscribe({
        next: data => {
          console.log('subscribed-data-event@', listen_topic, data);        
          message_setter(data);
        },
        error: error => {
          console.log('pubsub throw error');
          console.error(error)
        },
        complete: () => console.log("Complete")
      });
      console.log('Subscribed and listening!')
      setMyPubSub(mysub);
      console.log(mysub);
    } else console.log('ignore. already subscribed. ');

  }

  const handleBeforeUnload = (event) => {
    event.preventDefault();   
    console.log('hanle the before unload now');
    handleEndConcert();
    alertUser();
    // Customize the confirmation message
    event.returnValue = ''; // Some browsers require a non-empty string
  };

  useEffect(() => {

    console.log('starting useEffect once');    
    setIsSubscribed(true);
    /*
    const get_item_name = switchInfo.serialNumber + "/isSubscribed"
    console.log("getting localstorage item n/v for ", get_item_name);
    const data = window.localStorage.getItem(get_item_name);
    console.log('if localstorage data exists',JSON.parse(data));
    if ( data !== null ) {
      const got_sub_value = JSON.parse(data);
      console.log('not null. Setting isSubscribed val is', got_sub_value);
      setIsSubscribed(got_sub_value)
      uhcThingSubscribe();
    } else  {
      console.log('no localstorage. subscribe defaults true')
      setIsSubscribed(true);
    }*/
    uhcThingSubscribe();
    window.addEventListener('beforeunload', handleBeforeUnload);
    //window.addEventListener('unload', handleEndConcert)
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);     
      //window.removeEventListener('unload', handleEndConcert)      
    }
  }, []);

  const alertUser = e => {
    console.log('this is uvu alertUser');
    e.preventDefault();
    e.returnValue = '';
  }

  const handleEndConcert = async () => {
    console.log('Ending concert now')  
    setIsSubscribed(false);
    stopAll();
    console.log('Done. Show over.')
  }

  async function sendPayload() {
    var simple_payload_string = '{"Output":"Relay","Relays":[{"relay":"Rel2", "state":2}]}';
    var pub_payload = JSON.parse(simple_payload_string);
    console.log(myTopic,pub_payload)
    await PubSub.publish({ topics: [myTopic], message: pub_payload  });
    //var pc = my_AWSIoT.connect();
    //console.log(pc);
    await PubSub.publish(myTopic, pub_payload);
    await PubSub.publish({topics: 'policy/relays/4091511c51cd',  msg: 'Hello to all subscribers!' } );
    const z =  await PubSub.publish({topics: myTopic,    message: simple_payload_string });
    console.log(z);
  }

  async function stopAll() {
    if (subCounter > 0) {
      setSubCounter(subCounter-1);     
    }
    try {
      while (!MyPubSub.closed) { // was MyPubSub
        console.log('not closed. will now unsubscribe')
        MyPubSub.unsubscribe();
      }      
    } catch(error) {
      console.log('try/caught: while doing StopAll')
      console.log(error);
    }
    setSubCounter(0);
  }

  async function startAll() {
    uhcThingSubscribe();
 }

  return (
   
    <ThemeProvider theme={theme}>
      <Container
            sx={{
              display: 'flex',
              flexDirection: 'column', // Main axis runs vertically
              justifyContent: 'center',
              alignItems: 'center',
              height: '80vh',
            }}
      >
        <Card sx={{ display: 'flex', maxWidth: 640, backgroundColor: "lightgrey"}} variant="outlined" >
          <Box>
            <CardHeader
                action={
                  <IconButton aria-label="settings">
                    <MoreVertIcon />
                  </IconButton>
                }
                title =  {switchInfo.switch_aka?.S}
                subheader ={switchInfo.switch_id?.S}
            />
            <CardContent>

            <SwitchPoint switch_info={{topic:`policy/relays/${switchInfo.switch_id?.S}`, ucs:null}} />

              <ButtonGroup align="left">
                  <Button
                    id="relay1_state_button"
                    variant="contained"
                    endIcon={relay1Icon}
                    color={relay1Color}
                    size="small"
                  >
                    RELAY 1
                  </Button>

                  <Button
                    id="relay2_state_button"
                    variant="contained"
                    endIcon={relay2Icon}
                    color={relay2Color}
                    size="small"
                  >
                    RELAY 2
                  </Button>
              </ButtonGroup>
              <ButtonGroup align="left">
                <Button
                    id="gpio1_state_button"
                    variant="contained"
                    endIcon={<RadioButtonUncheckedIcon />}
                    color={gpio1Color}
                    size="small"
                  >
                    GPIO 1
                </Button>
                <Button
                    id="gpio2state_button"
                    variant="contained"
                    endIcon={<RadioButtonUncheckedIcon />}
                    color={gpio2Color}
                    size="small"
                >
                GPIO 2
                </Button>
                <Button
                  id="heartbeat"                  
                  endIcon={<FavoriteBorderIcon />}
                  size="small">{subCounter}</Button>
              </ButtonGroup>

             
          <Table
            sx={{ minWidth: 250,  width: 'fit-content',  pageSize:10}}
            size="small"
            aria-label="a dense table"           
          >
            <TableHead>
              <TableRow>
                <TableCell align="left">id</TableCell>
                  <TableCell align="left">Time</TableCell>
                <TableCell align="left">Message</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {messageData.map((msg_row,index) => (
                <TableRow key={msg_row.time}>
                  <TableCell component="th" scope="row" align="left" width="2" >                     
                    {index+1}
                  </TableCell>
                  <TableCell component="th" scope="row" align="left" width="1" >                     
                    <div className="textContainer"> {msg_row.time}</div>
                  </TableCell>
                  <TableCell align="left" width="50">
                    <div className="textContainer">{msg_row.message}</div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
            
            </CardContent>
            <CardActions >
                <IconButton aria-label="add to favorites">
                  <YellowSwitch
                    onChange={handleSubscriptionChange}
                    name="subscription"
                    id={switchInfo.serialNumber}
                    checked={isSubscribed}
                  />
                
                </IconButton>
                <IconButton aria-label="share">
                  <ShareIcon />
                </IconButton>

                <Switch 
                  {...label} 
                  onChange={relayChange} 
                  name="relay1"  
                  key={switchInfo.serialNumber} 
                />
                
                <Switch
                  {...label}
                  onChange={relayChange}
                  name="relay2"
                  key={switchInfo.serialNumber}         
                />

                <Button onClick={sendPayload} >SEND-PAYLOAD</Button>
                <Button onClick={stopAll} >STOP-ALL</Button>
                <Button onClick={startAll} >START-ALL</Button>

            </CardActions>           
            </Box>
        </Card>
      </Container>
    </ThemeProvider >
  );

}
